import { numberToString } from "./numberOperations";

export const parseJwt = (token: string) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));

    return JSON.parse(jsonPayload);
};

export const hasValue = (value: any): boolean => {
    const has: boolean = value !== undefined && value !== null;
    const valueType: any = typeof value;

    if (has && valueType === "string") {
        return value.toString().length > 0;
    }

    return has;
};

export const projectTimeToString = (planned?: number, remaining?: number) => {
    planned = planned ?? 0;
    remaining = remaining ?? 0;

    let plannedString = `${numberToString(Math.round((planned / 8) * 100) / 100)} MD`;
    let remainsString = `${numberToString(Math.round((remaining / 8) * 100) / 100)} MD`;

    if (planned < 8) {
        plannedString = `${numberToString(planned)} MH`;
    }

    if (remaining < 8) {
        remainsString = `${numberToString(remaining)} MH`;
    }

    return `Naplánováno ${plannedString} a zbývá ${remainsString}`;
};

export const projectStatuses = [
    { code: 100000000, text: "Nový", closedStatus: false },
    { code: 1, text: "Probíhá", closedStatus: false },
    { code: 2, text: "Pozastaveno", closedStatus: false },
    { code: 3, text: "Čeká se na detaily", closedStatus: false },
    { code: 5, text: "Uzavřeno", closedStatus: true },
    { code: 6, text: "Zrušeno", closedStatus: true }
];

export const projectStatusCodeToText = (code: number) => {
    return projectStatuses.filter(x => x.code === code)[0].text;
};

export const projectStatusTextToCode = (text: string) => {
    return projectStatuses.filter(x => x.text === text)[0].code;
};

export const colorByTime = (plannedHours: number, remainingHours: number): string => {
    if (plannedHours === 0) { return "transparent"; }

    const percent: number = remainingHours / plannedHours;
    if (percent > 0 && percent <= 0.2) { return "#ffa500"; }
    else if (percent <= 0) { return "#da4f43"; }
    else { return "transparent"; }
};

export const priorities = [
    { code: 0, text: "Nízká" },
    { code: 1, text: "Normální" },
    { code: 2, text: "Vysoká" }
];

export const priorityCodeToText = (code: number) => {
    return priorities.filter(x => x.code === code)[0].text;
};

export const priorityTextToCode = (text: string) => {
    return priorities.filter(x => x.text === text)[0].code;
};

export const slaColor = (status: string, terminalStateReached: boolean, warningTime: Date, failureTime: Date): string => {
    if (status === "Noncompliant") { return "#da4f43"; }
    if (status === "Succeeded") { return "#25C22A"; }
    if (terminalStateReached) { return ""; }
    if (new Date() > new Date(failureTime)) { return "#da4f43"; }
    if (new Date() > new Date(warningTime)) { return "#ffa500"; }
    return "";
};

export const copyToClipboard = (value: string): void => {
    const el = document.createElement("input");
    el.setAttribute("type", "text");
    el.value = value;

    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};

export const getVacationReportLink = (dataverseUserId: string) => {
    return import.meta.env.VITE_PBI_VACATION_URL?.replace("[UserId]", dataverseUserId);
}

export const removeHtmlTags = (html: string): string => {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
}
